"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridItem = exports.FeaturedItem = void 0;
exports.default = ProductGrid;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _productGridItem = _interopRequireDefault(require("./product-grid-item"));
var _productGridFeaturedItem = _interopRequireDefault(require("./product-grid-featured-item"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
/* VENDOR */

/* LOCAL */

const ProductGridSection = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "ProductGridSection",
  class: "pl-pfezn67"
});
const Grid = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Grid",
  class: "pl-gpi3dqo"
});
const GridItem = exports.GridItem = /*#__PURE__*/(0, _react2.styled)(_productGridItem.default)({
  name: "GridItem",
  class: "pl-g142dare"
});
const FeaturedItem = exports.FeaturedItem = /*#__PURE__*/(0, _react2.styled)(_productGridFeaturedItem.default)({
  name: "FeaturedItem",
  class: "pl-f163025c"
});

/**
 * Render ProductGrid
 * @module ProductGrid
 *
 * @param {Object} props React props
 * @param {String} props._name Promo Tracking Name
 * @param {array} [props.productItems] Product Grid Items array
 * @param {Object} [props.featuredCampaign] Featured product grid item
 * @param {string} [props.enableHoverEffect] Hover effect class
 * @param {String} props.verticalMargin Vertical Outer Spacing Values
 * @returns {React.ReactElement} ProductGrid component
 * @public
 */
function ProductGrid({
  _name,
  productItems = [],
  featuredCampaign,
  enableHoverEffect = 'none',
  verticalMargin
}) {
  if (!productItems || productItems.length < 1) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(ProductGridSection, {
    _name: _name,
    dataCy: "product-grid",
    className: "legacy-container",
    verticalMargin: verticalMargin
  }, /*#__PURE__*/_react.default.createElement(Grid, {
    hoverEffect: enableHoverEffect
  }, productItems.map((item, index) => {
    return /*#__PURE__*/_react.default.isValidElement(item) ? (/*#__PURE__*/_react.default.cloneElement(item, {
      ...item.props,
      key: item.id || index,
      hoverEffect: enableHoverEffect !== 'none'
    })) : /*#__PURE__*/_react.default.createElement(GridItem, (0, _extends2.default)({
      key: index,
      hoverEffect: enableHoverEffect !== 'none'
    }, item));
  }), featuredCampaign && (/*#__PURE__*/_react.default.isValidElement(featuredCampaign) ? (/*#__PURE__*/_react.default.cloneElement(featuredCampaign, {
    ...featuredCampaign.props,
    hoverEffect: enableHoverEffect !== 'none'
  })) : /*#__PURE__*/_react.default.createElement(FeaturedItem, (0, _extends2.default)({
    hoverEffect: enableHoverEffect !== 'none'
  }, featuredCampaign)))));
}
ProductGrid.propTypes = {
  _name: _propTypes.default.string,
  productItems: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array]).isRequired,
  featuredCampaign: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.shape(_productGridFeaturedItem.default.propTypes)]),
  enableHoverEffect: _propTypes.default.string,
  ..._patternLibraryUtils.marginProps
};